import type { Transaction } from "@rocicorp/zero";
import { userFacingError } from "../../authorization";
import { type Schema, zql } from "../../generatedDrizzleSchema";
import { SHAREABLE_SCOPE_KINDS, type ShareableScopeKind } from "../permissions";

const SCOPE_KIND_LABELS: Record<ShareableScopeKind, string> = {
  space: "spaces",
  connected_app: "connectors",
  skill: "skills",
  network: "networks",
  service_account: "service accounts",
};

const scopeList = new Intl.ListFormat("en", {
  style: "long",
  type: "conjunction",
}).format([
  ...SHAREABLE_SCOPE_KINDS.map((k) => SCOPE_KIND_LABELS[k]),
  "tenant roles",
]);

// Shared by the backend guard (below) and the group-settings UI, which disables
// delete with the same wording so the two can't drift.
export const GROUP_DELETE_BLOCKED_MESSAGE = `Remove this group from all ${scopeList} before deleting it`;

export async function assertGroupDeletable(
  tx: Pick<Transaction<Schema>, "run">,
  userGroupId: string
): Promise<void> {
  const externalGrants = await tx.run(
    zql.roleGrants
      .where("userGroupId", userGroupId)
      .where("scopeId", "!=", userGroupId)
  );
  if (externalGrants.length > 0) {
    throw userFacingError(GROUP_DELETE_BLOCKED_MESSAGE);
  }
}
